import CarouselItem from './Carousel.interface';

import IconsCarouselItem from "./Icons/Icons";
import BoxesCarouselItem from "./Boxes/Boxes";
import LinksCarouselItem from "./Links/Links";
import FlippingCarouselItem from "./Flipping/Flipping";
import EventsCarouselItem from "./Events/Events";
import MiniNewsICarouselItem from "./MiniNews/MiniNews";

interface Props {
    carouselType: string;
    isApiList: boolean;
    carouselItem: CarouselItem;
    getLinksHasImages: () => boolean;
    getIconsHasImages: () => boolean;
    dir: string;
    setFlipAll: (flipAll: boolean) => void;
    isflipAll: boolean;
    title: string;
    typeOfEventCarousel: string;
}

const CarouselItemComponent: React.FC<Props> = (props) => {

    const { carouselType } = props;

    if (carouselType === "Links") return <LinksCarouselItem {...props} />;

    if (carouselType === "Boxes") return <BoxesCarouselItem {...props} />;

    if (carouselType === "Flippings") return <FlippingCarouselItem {...props} />;

    if (carouselType === "Events") return <EventsCarouselItem {...props} />;

    if (carouselType === "MiniNews") return <MiniNewsICarouselItem {...props} />;

    // Default
    return <IconsCarouselItem {...props} />;

}

export default CarouselItemComponent;